import './Icon_Users.css';
import {ReactComponent as UserIcon} from '../Icons_Audience_Outline_Brand.svg'

function Icon_Users() {
  return (
    
      <div className='users-icon-container'>
          <UserIcon className="users-icon-svg" />
      </div>
            
  );
}

export default Icon_Users;

//<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-receipt-icon lucide-receipt"><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/><path d="M12 17.5v-11"/></svg>
